import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {apiGetPermissions} from "../../api/permissionApi";
import {apiGetProjects} from "../../api/projectApi";
import {apiGetPersonCategories, apiGetProductCategories} from "../../api/categoryApi";
import {apiGetBusinessCurrencies} from "../../api/currencyApi";
import {apiGetRoles} from "../../api/roleApi";
import {guideTabs} from "../../forms/GuideForm";
import {appSetBackUrl, appSetDashboardGuideData} from "../../store/actions/appAction";
import DashboardLayout from "../../components/Layouts/DashboardLayout";

import iconPlushAddFactor from "../../assets/svg/iconPlushAddFactor.svg";
import iconNextStep from "../../assets/svg/iconNextStep.svg";
import iconPrevStep from "../../assets/svg/prevStepIcon.svg";
import arrowTopDashboard from "../../assets/svg/arrow-top-dashboard.svg";
import iconSteperDashboard from "../../assets/svg/iconSteperDashboard.svg";
import GuidePlayerIcon from "../../assets/icons/GuidePlayerIcon";

import "../../assets/styles/dashboard/dashboard.scss";
import {Box, Button, Modal} from "@mui/material";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#fff",
    p: 2,
    borderRadius: "8px",
};

export default function DashboardGuide() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const backData = useSelector((state) => state).appReducer.backData;
    const business = useSelector((state) => state).businessReducer.business;
    const token = useSelector((state) => state).appReducer.token;

    const [activeTab, setActiveTab] = useState(guideTabs[0]);

    const [open, setOpen] = React.useState(false);
    const [videoUrl, setVideoUrl] = React.useState("");
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (business) {
            dispatch(apiGetBusinessCurrencies(business.token));
            // dispatch(apiGetBranches(business.token));
            dispatch(apiGetProjects(business.token));
            dispatch(apiGetRoles(business.token));
            dispatch(apiGetPermissions(business.token));
            dispatch(apiGetPersonCategories(business.token));
            dispatch(apiGetProductCategories(business.token));
            // dispatch(apiGetNotifications(business.token));
        }

        if (backData?.dashboardTabLevel) {
            updateActiveTab(backData.dashboardTabLevel);
            dispatch(appSetBackUrl(null, null));
        }
    }, []);

    const updateActiveTab = (level) => {
        const newTab = guideTabs.find((g) => g.level === level);
        if (newTab) {
            setActiveTab(newTab);
        }
    };

    return (
        <DashboardLayout hideEditButton={true}>
            <div className="flex flex-1 flex-col items-center ">
                <div className="wrap-content-box mb-24 mt-0 md:mt-12 w-full md:w-3/4 ">
                    <div className="flex items-start justify-between flex-row-reverse flex-wrap md:flex-nowrap">
            <span
                className="p-6 cursor-pointer"
                onClick={() => {
                    dispatch(appSetDashboardGuideData(false));
                }}
            >
              <img src={arrowTopDashboard} alt="arrowTopDashboard"/>
            </span>
                        <div className="flex items-center justify-around w-full p-4 gap-2">
                            {guideTabs.map((item, i, a) => {
                                return (
                                    <div key={i} className="flex gap-2 w-full">
                                        <div
                                            className="flex flex-col justify-center items-center gap-2 md:w-4 cursor-pointer"
                                            onClick={() => updateActiveTab(item.level)}
                                        >
                                            {item.level === activeTab.level ? (
                                                <img className="w-4 h-4" src={iconSteperDashboard}
                                                     alt="iconSteperDashboard"/>
                                            ) : (
                                                <div
                                                    className="w-4 h-4 rounded-full border-2 border-white bg-[#aeaeae]"/>
                                            )}
                                            <div className="whitespace-nowrap">
                                                {item.title} <span>{item.time}</span>
                                            </div>
                                        </div>
                                        {i + 1 < a.length && <div className="h-px bg-[#aeaeae] w-full mt-2"/>}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="wrap-content-data-step">
                        <div className="title-step-data">{activeTab.guide.title}</div>
                        <div className="img-logo-step-data d-flex justify-content-center  ">
                            {activeTab.guide.videos ? (
                                activeTab.guide.videos.map(
                                    (item, index) =>
                                        item?.thumbnail && (
                                            <div key={index} style={{flex: 1}}>
                                                <Button
                                                    onClick={() => {
                                                        setVideoUrl(item.url);
                                                        handleOpen();
                                                    }}
                                                >
                                                    <GuidePlayerIcon title={""} link={item?.thumbnail}/>
                                                </Button>
                                            </div>
                                        )
                                )
                            ) : (
                                <img src={activeTab.guide.img} alt="stepImg"/>
                            )}
                        </div>
                        <div className="mb-4 flex justify-center">
                            <p className="max-w-[600px] text-center">{activeTab.guide.description}</p>
                        </div>
                        {activeTab.guide.link ? (
                            <div className="btns-step-data">
                                <button
                                    type="button d-flex"
                                    onClick={() => {
                                        dispatch(
                                            appSetBackUrl("/dashboard", {
                                                dashboardTabLevel: activeTab.level,
                                            })
                                        );
                                        navigate(activeTab.guide.link);
                                    }}
                                >
                                    {activeTab.level < 6 ? (
                                        <img src={iconPlushAddFactor} className="inline" alt="iconPlushAddFactor"/>
                                    ) : null}
                                    <span>{activeTab.guide.textButton}</span>
                                </button>
                            </div>
                        ) : null}
                        <div className="next-step-prev-step mt-10">
                            <div className="prev-step d-flex" onClick={() => updateActiveTab(activeTab.level - 1)}>
                                {activeTab.level > 1 ? (
                                    <>
                                        <img src={iconPrevStep} alt="iconPrevStep"/>
                                        بازگشت
                                    </>
                                ) : null}
                            </div>
                            <div className="next-step d-flex" onClick={() => updateActiveTab(activeTab.level + 1)}>
                                {activeTab.level < 6 ? (
                                    <>
                                        مرحله بعد
                                        <img src={iconNextStep} alt="iconNextStep"/>
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                {/*{activeTab.guide.videos ? (*/}
                {/*    //   ? activeTab.guide.videos.map((video) => (*/}
                {/*    //       <div className="wrap-header-instructional-videos">*/}
                {/*    //         <div className="wrap-header-content-box-video">*/}
                {/*    //           ویدیو های آموزشی*/}
                {/*    //         </div>*/}
                {/*    //       </div>*/}
                {/*    //     ))*/}
                {/*    <div className="flex w-3/4 bg-white rounded-lg  flex-col ">*/}
                {/*        <div className="flex  w-full border-b-2 border-[#f6f6fa] p-4 ">*/}
                {/*            <span className="text-base font-medium ">ویدیو های آموزشی</span>*/}
                {/*        </div>*/}
                {/*        <div className="flex flex-col w-full p-4">*/}
                {/*            {activeTab.guide.videos.map((item, index) => (*/}
                {/*                <div className="flex flex-row w-full" key={index}>*/}
                {/*                    <div>*/}
                {/*                        {item?.thumbnail && (*/}
                {/*                            <div style={{flex: 1, paddingRight: "40px"}}>*/}
                {/*                                <Button*/}
                {/*                                    onClick={() => {*/}
                {/*                                        setVideoUrl(item.url);*/}
                {/*                                        handleOpen();*/}
                {/*                                    }}*/}
                {/*                                >*/}
                {/*                                    <GuidePlayerIcon title={""} link={item?.thumbnail}/>*/}
                {/*                                </Button>*/}
                {/*                            </div>*/}
                {/*                        )}*/}
                {/*                    </div>*/}
                {/*                    <div className="flex p-3 flex-col w-full">*/}
                {/*    <span className="flex text-base font-medium text-black ">*/}
                {/*      {item.title}*/}
                {/*    </span>*/}
                {/*                        <div className="flex flex-wrap w-full mt-3 items-center">*/}
                {/*                            {item.questions.map((item, index) => (*/}
                {/*                                <div*/}
                {/*                                    key={index}*/}
                {/*                                    className="w-1/2 flex flex-row items-center text-right mt-4"*/}
                {/*                                >*/}
                {/*                                    <svg*/}
                {/*                                        width="24"*/}
                {/*                                        height="24"*/}
                {/*                                        viewBox="0 0 24 24"*/}
                {/*                                        fill="none"*/}
                {/*                                        xmlns="http://www.w3.org/2000/svg"*/}
                {/*                                        className="mb-1"*/}
                {/*                                    >*/}
                {/*                                        <path*/}
                {/*                                            d="M20 7 10 17l-5-5"*/}
                {/*                                            stroke="#1062D0"*/}
                {/*                                            strokeWidth="2.5"*/}
                {/*                                            stroke-linecap="round"*/}
                {/*                                            stroke-linejoin="round"*/}
                {/*                                        />*/}
                {/*                                    </svg>*/}
                {/*                                    <span className="text-[#8D8E8F]">{item}</span>*/}
                {/*                                </div>*/}
                {/*                            ))}*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            ))}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*) : null}*/}
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{...style}}>
                    <video autoPlay={true} src={videoUrl} width={800} controls={true}></video>
                </Box>
            </Modal>
        </DashboardLayout>
    );
}
